import './styles.css';

import clsx from 'clsx';
import Image from 'next/image';

import { ChevronRightIcon } from '@/shared';

import { Button } from '../../';
import type { ICTAFreeStart } from '../../types';

export const CTAFreeStart = ({
	title,
	image,
	imagePosition = 'right',
	backgroundImage,
	pricing,
	button,
}: ICTAFreeStart) => {
	const backgroundStyle = backgroundImage
		? {
				backgroundImage: `url(${backgroundImage})`,
			}
		: {};

	const contentElement = (
		<div
			className={clsx({
				'md:order-1': image && imagePosition === 'right',
				'md:order-2': image && imagePosition === 'left',
			})}
		>
			<h2 className="cta-title">{title}</h2>

			<div className="mt-6 flex flex-col gap-6 xl:mt-12 xl:flex-row xl:gap-12">
				<dl>
					<dt className="mb-2 text-xs opacity-70 xl:text-base">
						{pricing.coursePrice.label}
					</dt>
					<dd className="text-base/[1.2] xl:text-2xl">
						<span>{pricing.coursePrice.value}</span>
						{pricing.coursePrice.additionalInfo && (
							<small className="mt-1 block text-[10px]/[1.2] text-[#C4CADA] xl:text-sm">
								{pricing.coursePrice.additionalInfo}
							</small>
						)}
					</dd>
				</dl>
				<dl>
					<dt className="mb-2 text-xs opacity-70 xl:text-base">
						{pricing.paymentFormat.label}
					</dt>
					<dd className="text-sm xl:text-2xl">{pricing.paymentFormat.value}</dd>
				</dl>
			</div>

			<div className="mt-12">
				<Button
					href={button.href}
					variant="white"
					size="72"
					className="cta-action"
				>
					{button.text}
					<ChevronRightIcon className="size-5" />
				</Button>
			</div>
		</div>
	);

	const imageElement = image && (
		<div
			className={clsx('h-full flex-1 flex-shrink-0', {
				'md:order-2': imagePosition === 'right',
				'md:order-1': imagePosition === 'left',
			})}
		>
			<Image
				src={image.src}
				alt={image.alt}
				width={400}
				height={300}
				className="h-full w-full rounded-2xl object-cover xl:rounded-3xl 2xl:rounded-[60px]"
			/>
		</div>
	);

	return (
		<div
			className={clsx('cta cta-free-start w-full xl:items-center', {
				'with-background': backgroundImage,
				'flex flex-col justify-between gap-12 xl:flex-row': image,
			})}
			style={backgroundStyle}
		>
			{imagePosition === 'left' ? (
				<>
					{imageElement}
					{contentElement}
				</>
			) : (
				<>
					{contentElement}
					{imageElement}
				</>
			)}
		</div>
	);
};
